var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "full-screen-modal",
      attrs: {
        id: "recap-add-brouillon-modal",
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "ok-variant": "primary"
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                {
                  staticClass:
                    "w-100 d-flex row col-12 justify-content-start align-items-center"
                },
                [
                  _c("i", {
                    staticClass:
                      "ph-custom ph-caret-circle-left-bold mr-2 mt-1 cursor-pointer",
                    on: { click: _vm.backToHideAnnonce }
                  }),
                  _vm._v(" "),
                  _c("h1", { staticClass: "page-title" }, [
                    _vm._v(_vm._s(_vm.$t("annonce.my.draft")))
                  ])
                ]
              )
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100 mr-2 d-none d-md-block",
                      attrs: { variant: "secondary" },
                      on: {
                        click: function($event) {
                          return _vm.handleSubmit()
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Close")))]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v(_vm._s(_vm.$t("annonce.select.draft")))]),
        _vm._v(" "),
        !_vm.isLoading
          ? _c(
              "div",
              [
                _c(
                  "transition-group",
                  {
                    staticClass: "item-container-draft",
                    attrs: { name: "listCustomTransition", tag: "div" }
                  },
                  [
                    _vm._l(_vm.drafts, function(annonce, index) {
                      return _c(
                        "div",
                        {
                          key: index + "-draft",
                          staticClass: "item-draft d-flex",
                          on: {
                            click: function($event) {
                              return _vm.selectDraft(annonce)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 d-flex align-items-center justify-content-center p-2"
                            },
                            [
                              annonce.vehicleFiles.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "container-img-draft" },
                                    [
                                      _c("img", {
                                        staticClass: "rounded",
                                        attrs: {
                                          src:
                                            annonce.vehicleFiles[0].url ||
                                            annonce.vehicleFiles[0].safeUrl ||
                                            annonce.vehicleFiles[0].fileUrl,
                                          alt: "Annonce Image"
                                        }
                                      })
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "container-img-draft" },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "rounded no-result-img-draft",
                                        attrs: {
                                          src: require("@/assets/images/b122/PLACEHOLDER.png"),
                                          alt: "no result"
                                        }
                                      })
                                    ]
                                  )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-8 d-flex flex-column justify-content-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex justify-content-between"
                                },
                                [
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.getAnnonceStr(annonce)))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center mt-2"
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "ph ph-custom ph-scan main-color cursor-pointer"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "ml-2" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayValueOrNA(
                                          _vm.formatAnnonceInfo(annonce)
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center mt-2"
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "ph ph-custom ph-map-pin main-color cursor-pointer"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "ml-2" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayValueOrNA(annonce.address)
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.drafts.length === 0
                      ? _c("div", { key: "no-draft-available" }, [
                          _c("div", { staticClass: "no-result" }, [
                            _c(
                              "div",
                              { staticClass: "text-center mt-5 mb-2" },
                              [
                                _c("img", {
                                  staticClass: "no-result-img",
                                  attrs: {
                                    src: require("@/assets/images/b122/img-perso-ok.png"),
                                    alt: "no result"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "no-result-text" }, [
                              _c(
                                "div",
                                { staticClass: "no-result-title mb-2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "annonce.recap.add.draft.emptyTitle"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("annonce.recap.add.draft.emptyText")
                                  )
                                )
                              ])
                            ])
                          ])
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51f40da4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f40da4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/annonce/RecapAddBrouillonAnnonceModal.vue
// module id = f/fq
// module chunks = 0